/**
 * Portal-Reiter Baustein.
 * Namen und Gruppen: docs/intern/RECHTSTEXTE_KONSISTENZ.md Abschnitt E
 * (Schema intern ANKER 20.09.2026, auf main).
 * Anker-Euro stehen dort als intern / nicht Website — nicht in dieser Fläche.
 */

export interface BausteinZeile {
  name: string;
  note?: string;
}

export const BAUSTEIN_LEAD =
  'Angebot = Basis + Module. Ein Gestell für Einzelanwalt und Großkanzlei. Kein Homepage-Pauschalpaket.';

export const BAUSTEIN_BASIS_HEADING = 'Basis (Minimum für den Betrieb)';

export const BAUSTEIN_BASIS: readonly BausteinZeile[] = [
  {
    name: 'Orbis-Plattform',
    note: 'Kanzlei-Plattform (Arbeitsumgebung); keine einzeln verkauften Fremdprodukt-Lizenzen',
  },
  {
    name: 'Edge-Betrieb / Hosting',
    note: 'nur wenn Betrieb ARKORBIT',
  },
  {
    name: 'Backup / Updates',
    note: 'betriebliche Mindestpflege der Instanz',
  },
  {
    name: 'Basis-Support',
    note: 'E-Mail, Werktag — in der Basis, keine Extra-Zeile',
  },
  {
    name: '1 Admin-Zugang',
    note: 'ein administrativer Zugang; weitere Sitze = Modul',
  },
];

export const BAUSTEIN_MODULE_HEADING = 'Module (extra, Zeile je Modul)';

export const BAUSTEIN_MODULE: readonly BausteinZeile[] = [
  { name: 'Sitze', note: '1 Admin in der Basis; weitere Sitze = Modul' },
  { name: 'Diktat', note: 'Modul, nicht Basis' },
  { name: 'ARKO', note: 'Modul, nicht Basis' },
  {
    name: 'LEXCORE-Fach',
    note: 'Verkaufsmodul. Basis-LEXCORE bleibt Alt-Kanon bis FINAL-Entscheidung.',
  },
  { name: 'JUDICATURE' },
  {
    name: 'Litigation',
    note: 'nicht im Standard-/3er-Grundangebot. Einstieg OFFEN.',
  },
  {
    name: 'Support Plus',
    note: 'Nicht verkaufen, bis ein fixer Mitarbeiter für den Plus-Dienst da ist. Basis-Support bleibt in der Basis.',
  },
];

export const BAUSTEIN_PAKETE_HEADING = 'Keine öffentlichen Pakete Professional / Premium';

export const BAUSTEIN_PAKETE_NOTE =
  'Öffentlich keine Paketnamen Professional/Premium. Intern nur als Angebotsvorlagen aus Basis + Module.';

export const BAUSTEIN_VORLAGEN_HEADING = 'Zwei Angebotsvorlagen';

export interface BausteinVorlage {
  name: string;
  note?: string;
  zeilen: readonly BausteinZeile[];
}

export const BAUSTEIN_VORLAGEN: readonly BausteinVorlage[] = [
  {
    name: 'Betrieb ARKORBIT',
    zeilen: [
      { name: 'Hosting-Zeile', note: 'Edge-Betrieb/Hosting in der Basis' },
      { name: 'Setup / Box', note: 'einmalig je neuer Infrastrukturinstanz' },
      { name: 'Server', note: 'dedizierter Edge bei ARKORBIT' },
    ],
  },
  {
    name: 'Betrieb Kanzlei',
    note: 'eigener Server / On-Prem',
    zeilen: [
      { name: 'Hosting-Zeile', note: '0' },
      { name: 'Setup und Abnahme', note: 'extra; nicht in diesem Fix-Paket auspreisen' },
      { name: 'Server', note: 'Hardware-Mindestanforderungen OFFEN / später' },
    ],
  },
];

export const BAUSTEIN_MUSTER_HEADING = 'Muster Grundausstattung 3 Personen';

export const BAUSTEIN_MUSTER: readonly BausteinZeile[] = [
  { name: 'Basis Betrieb ARKORBIT' },
  { name: '2 Sitze extra' },
  { name: 'Diktat' },
  { name: 'ARKO' },
];

export const BAUSTEIN_MUSTER_OHNE = 'Litigation nicht in diesem Muster';
